/**
 * Milano Straps — Wishlist Module
 * Uses event delegation: works regardless of when buttons are added to DOM.
 */

(function () {
  'use strict';

  // ⚠️ 2026-07-25. Prima si chiamava admin.milanostraps.it IN DIRETTA. Quell'endpoint
  // pretende la firma App Proxy (audit sicurezza 29/05) che una chiamata diretta non
  // può avere: rispondeva 401 a OGNI salvataggio e la wishlist era morta da due mesi.
  // Ora si passa dall'App Proxy: percorso RELATIVO sul negozio, così è Shopify a
  // firmare la richiesta e ad aggiungere `logged_in_customer_id` (che lato server
  // vince sul cliente scritto nella pagina — anti-IDOR).
  // Sta sotto /a/orologi perché una app Shopify può avere UN SOLO proxy e i due che
  // abbiamo sono già assegnati; il proxy inoltra qualunque sottopercorso.
  var WISHLIST_API_ADD    = '/a/orologi/api/wishlist/add';
  var WISHLIST_API_REMOVE = '/a/orologi/api/wishlist/remove';
  var LS_PREFIX    = 'ms_wl_';

  // ── localStorage ──────────────────────────────────────────────────

  function isWishlisted(productId) {
    try { return localStorage.getItem(LS_PREFIX + productId) === '1'; } catch (_) { return false; }
  }

  function markWishlisted(productId) {
    try { localStorage.setItem(LS_PREFIX + productId, '1'); } catch (_) {}
  }

  // ── Button state ──────────────────────────────────────────────────

  function setButtonState(btn, state) {
    var icon  = btn.querySelector('.ms-wishlist-icon');
    var label = btn.querySelector('.ms-wishlist-label');

    if (state === 'active') {
      btn.classList.add('ms-wishlist-btn--active');
      btn.disabled = false;
      if (icon)  icon.textContent  = '♥';
      if (label) label.textContent = 'Nella wishlist';
      btn.setAttribute('aria-pressed', 'true');
    } else if (state === 'saving') {
      btn.disabled = true;
      if (icon)  icon.textContent  = '♡';
      if (label) label.textContent = 'Salvataggio…';
    } else if (state === 'error') {
      btn.classList.remove('ms-wishlist-btn--active');
      btn.disabled = false;
      if (icon)  icon.textContent  = '!';
    } else {
      btn.classList.remove('ms-wishlist-btn--active');
      btn.disabled = false;
      if (icon)  icon.textContent  = '♡';
      if (label) label.textContent = 'Aggiungi alla wishlist';
      btn.setAttribute('aria-pressed', 'false');
    }
  }

  // ── Accesso ───────────────────────────────────────────────────────
  // ⚠️ 2026-07-25. Qui c'erano DUE difetti che insieme facevano dire
  // «il cuoricino non funziona» a chi non ha fatto l'accesso:
  //
  // 1. Si usava `/account/login?return_url=…`, il contratto dei VECCHI account
  //    cliente. Questo negozio è sui NUOVI (account.milanostraps.it): quel
  //    percorso butta via il return_url e scarica la persona sulla home
  //    dell'account, fuori dal negozio. Verificato con la catena di redirect.
  //    Il contratto giusto è `/customer_authentication/login?return_to=<path
  //    RELATIVO>` (shopify.dev/docs/storefronts/themes/sign-in): passa da
  //    authorize con redirect_uri sul NOSTRO dominio e riporta indietro.
  // 2. Anche tornando indietro, l'intenzione era persa: il prodotto non
  //    veniva salvato e bisognava ricordarsi di ritoccare il cuore. Ora la
  //    intenzione si annota prima di partire e si esegue al ritorno.
  var LS_PENDENTE = 'ms_wl_pendente';

  function vaiAdAccedere(productId) {
    try { if (productId) localStorage.setItem(LS_PENDENTE, productId); } catch (_) {}
    var dove = window.location.pathname + window.location.search; // relativo: il parametro accetta solo URL relativi
    window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(dove);
  }

  // Al ritorno dall'accesso: se c'era un'intenzione in sospeso e ora la persona
  // è riconosciuta, si completa il gesto che aveva già fatto.
  function eseguiIntenzioneInSospeso() {
    var pendente;
    try { pendente = localStorage.getItem(LS_PENDENTE); } catch (_) { return; }
    if (!pendente) return;
    var btn = document.querySelector('.ms-wishlist-btn[data-product-id="' + pendente + '"]');
    if (!btn || !btn.dataset.customerId) return;   // non riconosciuta: si riproverà al prossimo accesso
    try { localStorage.removeItem(LS_PENDENTE); } catch (_) {}
    if (!isWishlisted(pendente)) handleClick(btn);
  }

  // ── Click handler ─────────────────────────────────────────────────

  function handleClick(btn) {
    var productId  = btn.dataset.productId;
    var customerId = btn.dataset.customerId;

    if (!productId) return;

    // Non ha fatto l'accesso → lo mandiamo ad accedere, ricordandoci COSA voleva.
    if (!customerId) {
      vaiAdAccedere(productId);
      return;
    }

    // Toggle: already wishlisted → remove
    if (isWishlisted(productId)) {
      setButtonState(btn, 'saving');
      fetch(WISHLIST_API_REMOVE, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ shopify_customer_id: customerId, shopify_product_id: productId }),
      })
      .then(function () {
        try { localStorage.removeItem(LS_PREFIX + productId); } catch (_) {}
        document.querySelectorAll('.ms-wishlist-btn[data-product-id="' + productId + '"]')
          .forEach(function (b) { setButtonState(b, 'default'); });
      })
      .catch(function () {
        // Even on network error, reset local state
        try { localStorage.removeItem(LS_PREFIX + productId); } catch (_) {}
        document.querySelectorAll('.ms-wishlist-btn[data-product-id="' + productId + '"]')
          .forEach(function (b) { setButtonState(b, 'default'); });
      });
      return;
    }

    // Add to wishlist
    setButtonState(btn, 'saving');

    var payload = {
      shopify_customer_id: customerId,
      customer_email: btn.dataset.customerEmail || '',
      product: {
        shopify_product_id: productId,
        shopify_variant_id: btn.dataset.variantId     || '',
        product_title:      btn.dataset.productTitle  || '',
        product_handle:     btn.dataset.productHandle || '',
        price:              btn.dataset.price         || '',
      },
    };

    fetch(WISHLIST_API_ADD, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload),
    })
    .then(function (res) {
      // ⚠️ Qui NON si rimanda al login. Passando dall'App Proxy, 401 vuol dire
      // «firma non valida», cioè un guasto nostro — non «non hai fatto l'accesso»
      // (quel caso è già intercettato prima della chiamata). Scambiare le due cose
      // è ciò che per due mesi ha spedito al login anche chi era già dentro,
      // all'infinito. Meglio un errore onesto che un giro senza uscita.
      if (res.status === 401) { setButtonState(btn, 'error'); return; }
      if (!res.ok) { setButtonState(btn, 'error'); return; }

      markWishlisted(productId);
      document.querySelectorAll('.ms-wishlist-btn[data-product-id="' + productId + '"]')
        .forEach(function (b) { setButtonState(b, 'active'); });
    })
    .catch(function (err) {
      console.error('[ms-wishlist]', err);
      setButtonState(btn, 'error');
    });
  }

  // ── Restore persisted state on existing buttons ───────────────────

  function restoreAll() {
    document.querySelectorAll('.ms-wishlist-btn').forEach(function (btn) {
      if (btn.dataset.productId && isWishlisted(btn.dataset.productId)) {
        setButtonState(btn, 'active');
      }
    });
  }

  // ── Event delegation — attached once on document ──────────────────

  document.addEventListener('click', function (e) {
    // difensivo: se il bersaglio non è un elemento (nodo di testo, document),
    // `closest` non esiste e qui si romperebbe OGNI click della pagina —
    // questo ascoltatore è in fase di cattura, davanti a tutti gli altri.
    var t = e.target;
    var btn = t && typeof t.closest === 'function' ? t.closest('.ms-wishlist-btn') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleClick(btn);
  }, true); // capture phase — fires before form submit handlers

  // Restore state after DOM ready
  function avvio() { restoreAll(); eseguiIntenzioneInSospeso(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvio);
  } else {
    avvio();
  }

  window.msWishlist = { isWishlisted, markWishlisted };
})();
